function city_select(zip_code_input) {
  var city_select_id = zip_code_input.dataset.citySelectId;
  var base_url = zip_code_input.dataset.url;
  var params = "zip_code=" + encodeURIComponent(zip_code_input.value);
  var url = base_url + "?" + params;
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);

  // Send the proper header information along with the request
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.responseType = "json";

  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
      var city_select = document.getElementById(city_select_id);
      if (!city_select) return;

      city_select.innerHTML = "";
      json = xhr.response;
      if (json.hasOwnProperty("error")) {
	city_select.classList.add("is-invalid")
        city_select.add(new Option(json.error, ""))
      } else {
	city_select.classList.remove("is-invalid")
	if (json.prompt) {
          city_select.add(new Option(json.prompt, ""))
	}
        json.cities.forEach((city) => {
          city_select.add(new Option(city, city))
        });
      }
    }
  };
  xhr.send(params);
}

window.city_select = city_select;
